export const retryCount = 3;
export const retryBlacklist = [403, 404];
export const trackErrorBlacklist = [401, 404, 500, 502];
